import CheckDepositHistory from './CheckDepositHistory';

export default CheckDepositHistory;
